const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const LINKER_DOMAINS = ["01london.com", "shop.01london.com"];
let loaded = false;

// Loads only when REACT_APP_GA4_ID is configured (e.g. "G-XXXXXXXXXX").
// Without it every helper below is a silent no-op.
export function initAnalytics() {
  if (!GA4_ID || loaded || typeof window === "undefined") return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID, {
    send_page_view: false, // SPA: we send page_view manually per route
    linker: { domains: LINKER_DOMAINS }, // cross-domain: 01london.com <-> shop.01london.com
  });
}

export function trackPageView(path) {
  if (!GA4_ID || !window.gtag) return;
  window.gtag("event", "page_view", { page_path: path, page_title: document.title });
}

export function trackEvent(name, params = {}) {
  if (!GA4_ID || !window.gtag) return;
  window.gtag("event", name, { currency: "GBP", ...params });
}

export const ga4Enabled = () => !!GA4_ID;
